import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { updateReceipt } from "../../../services/Aeat.jsx";
import Button from "../button/Button.jsx";
import NewMessagesButton from "../button/NewMessagesButton.jsx";
import SilicieButton from "../button/SilicieButton.jsx";
import ModalAceptacion from "../modal/aceptacion/ModalAceptacion.jsx";
import ModalUpdateReceiptDateOfArrival from "../modal/receipt/ModalUpdateReceiptDateOfArrival.jsx";
import ModalUpdateReceiptPrecintas from "../modal/receipt/ModalUpdateReceiptPrecintas.jsx";
import Table from "./Table.jsx";

const PAGE_SIZE = 10;

const TableReceipts = ({ data, error, loading, refetch, formData }) => {
  const [selectedArcs, setSelectedArcs] = useState({ receipts: [] });
  const [message, setMessage] = useState("");
  const [aceptacionModal, setAceptacionModal] = useState({ isOpen: false });
  const [precintasModal, setPrecintasModal] = useState({ isOpen: false, receiptId: null, name: null });
  const [dateOfArrivalModal, setDateOfArrivalModal] = useState({ isOpen: false, receiptId: null, name: null });
  const [shownData, setShownData] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (data !== null) {
      const sortedData = data.sort((a, b) =>
        new Date(a.date_and_time_of_validation) - new Date(b.date_and_time_of_validation)
      );
      setShownData(sortedData.slice(0, PAGE_SIZE));
      setPage(1);
    } else {
      setShownData([]);
      setPage(1);
    }
  }, [data]);

  useEffect(() => {
  }, [page]);

  const handlePreviousPage = (e) => {
    e.preventDefault();
    if (page > 1) {
      const newPage = page - 1;
      setPage(newPage);
      setShownData(data.slice((newPage - 1) * PAGE_SIZE, newPage * PAGE_SIZE));
    }
  };

  const handleNextPage = () => {
    if (page < (data.length / PAGE_SIZE)) {
      const newPage = page + 1;
      setPage(newPage);
      setShownData(data.slice((newPage - 1) * PAGE_SIZE, newPage * PAGE_SIZE));
    }
  };

  const handleOpenModal = (setModal, receiptId, receiptName) => {
    setModal({ isOpen: true, receiptId: receiptId, name: receiptName });
  };

  const handleCloseModal = (setModal) => {
    setModal({ isOpen: false, receiptId: null, name: null });
  };

  const handleSelectedRow = (row) => {
    const exists = selectedArcs.receipts.some(
      (selectedArc) => selectedArc.id === row.id,
    );

    if (exists) {
      setSelectedArcs({
        receipts: selectedArcs.receipts.filter(
          (selectedArc) => selectedArc.id !== row.id,
        ),
      });
    } else {
      setSelectedArcs({
        receipts: [
          ...selectedArcs.receipts,
          {
            id: row.id,
            arc: row.administrative_reference_code,
            lrn: row.local_reference_number,
          },
        ],
      });
    }
  };

  const handleUpdateReceipt = async (row) => {
    try {
      await updateReceipt(row.id);
    } catch (e) {
      console.log(e.message);
    }
    const filter = Object.fromEntries(
      Object.entries(formData)
        .filter(([_, value]) => value !== ""),
    );
    await refetch(filter);
  };

  const columns = [
    {
      header: "",
      render: (row) => (
        <input
          type={"checkbox"}
          disabled={!row.processed}
          checked={selectedArcs.receipts.some(
            (selectedArc) => selectedArc.id === row.id,
          )}
          onChange={() => handleSelectedRow(row)}
          className={"cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 border-gray-300 text-green-600 focus:ring-green-500"}
        >
        </input>
      ),
    },
    {
      header: "ARC",
      render: (row) => (
        <Link to={`/receipts/${row.id}`} className="hover:underline hover:text-blue-600">
          {row.administrative_reference_code}
        </Link>
      ),
    },
    { header: "Fecha Expedición", accessor: "date_of_preparation" },
    { header: "Situación", accessor: "situacion" },
    { header: "Procesado", render: (row) => row["processed"] ? "Completo" : "Incompleto" },
    { header: "N.I.F Destinatario", accessor: "message_recipient" },
    {
      header: "Fecha de Recepción",
      render: (row) => {
        if (row.date_of_arrival !== null) {
          return (
            <Button
              onClick={() => handleOpenModal(setDateOfArrivalModal, row.id, row.local_reference_number)}
              className="hover:underline hover:text-blue-600"
            >
              {row.date_of_arrival}
            </Button>
          );
        } else {
          return (
            <Button
              onClick={() => handleOpenModal(setDateOfArrivalModal, row.id, row.local_reference_number)}
              className="hover:underline text-blue-600"
            >
              Añadir
            </Button>
          );
        }
      },
    },
    {
      header: "Precintas",
      render: (row) => {
        if (row.precintas !== null) {
          return (
            <Button
              onClick={() => handleOpenModal(setPrecintasModal, row.id, row.local_reference_number)}
              className="hover:underline hover:text-blue-600"
            >
              {row.precintas}
            </Button>
          );
        } else {
          return (
            <Button
              onClick={() => handleOpenModal(setPrecintasModal, row.id, row.local_reference_number)}
              className="hover:underline text-blue-600"
            >
              Añadir
            </Button>
          );
        }
      },
    },
    {
      header: "",
      render: (row) => {
        return (
          <Button
            onClick={() => handleUpdateReceipt(row)}
            className="hover:underline text-blue-600"
          >
            Update
          </Button>
        );
      },
    },
  ];

  if (loading) return <div>Cargando declaraciones...</div>;
  if (error) return <div className="text-red-600">Error: {error.response.data.detail}</div>;
  if (!data || data.length === 0) return <div>No se han encontrado ninguna declaracion</div>;

  return (
    <div>
      <div className="w-full text-red-500 text-center">{message}</div>
      <div className="text-sm mb-2 space-x-2">
        <Button
          onClick={() => {
            setAceptacionModal({ isOpen: true });
          }}
        >
          Aceptar Selección
        </Button>
        <SilicieButton receipts={selectedArcs.receipts}>Generar Silicie</SilicieButton>
        <NewMessagesButton
          refetch={async () => {
            const filter = Object.fromEntries(
              Object.entries(formData)
                .filter(([_, value]) => value !== ""),
            );
            await refetch(filter);
          }}
        />
      </div>
      <Table columns={columns} data={shownData} />
      <div className="w-full">
        <div className="flex justify-center mt-4 space-x-4">
          <Button onClick={handlePreviousPage}>Siguiente</Button>
          <Button onClick={handleNextPage}>Anterior</Button>
        </div>
      </div>
      <ModalAceptacion
        isOpen={aceptacionModal.isOpen}
        onClose={() => setAceptacionModal({ isOpen: false })}
        refetch={async () => {
          const filter = Object.fromEntries(
            Object.entries(formData)
              .filter(([_, value]) => value !== ""),
          );
          await refetch(filter);
        }}
        receipts={selectedArcs.receipts}
      />
      <ModalUpdateReceiptPrecintas
        isOpen={precintasModal.isOpen}
        onClose={() => handleCloseModal(setPrecintasModal)}
        refetchTable={async () => {
          const filter = Object.fromEntries(
            Object.entries(formData)
              .filter(([_, value]) => value !== ""),
          );
          await refetch(filter);
        }}
        receiptId={precintasModal.receiptId}
      />
      <ModalUpdateReceiptDateOfArrival
        isOpen={dateOfArrivalModal.isOpen}
        onClose={() => handleCloseModal(setDateOfArrivalModal)}
        refetchTable={async () => {
          const filter = Object.fromEntries(
            Object.entries(formData)
              .filter(([_, value]) => value !== ""),
          );
          await refetch(filter);
        }}
        receiptId={dateOfArrivalModal.receiptId}
        receiptName={dateOfArrivalModal.name}
      />
    </div>
  );
};

export default TableReceipts;
